import institutionAPI from '@/services/api/institute/information'

const institutionInformation = {
	namespaced: true,
	state: () => ({
		name: '스마트잭',
		instInfo: {
			info: {
				logo: '',
				phone: '',
				name: '',
				address: '',
				traderRegistrationNumber: '',
			},
			license: {},
		},
		form: {
			info: {
				logo: '',
				phone: '',
				name: '',
				address: '',
				traderRegistrationNumber: '',
			},
		},
	}),
	getters: {
		institutionName: state => state.name,
		institutionInfo: state => state.instInfo,
	},
	mutations: {
		setInstInfo: (state, payload) => {
			state.instInfo = payload
		},
		setInstInfoAtForm: (state, payload) => {
			state.form = payload
		},
		setLogoUrl: (state, payload) => {
			state.form.info.logo = payload
		},
		setTraderNumber: (state, payload) => {
			state.form.info.traderRegistrationNumber = payload
		},
		setName: (state, payload) => {
			state.form.info.name = payload
		},
		setAddress: (state, payload) => {
			state.form.info.address = payload
		},
		setPhone: (state, payload) => {
			state.form.info.phone = payload
		},
		setLicense: (state, payload) => {
			state.license = payload
		},
	},
	actions: {
		loadInstitutionInfo: async ({ commit }, instId) => {
			const response = await institutionAPI.lookupInstInfo(instId)
			commit('setInstInfo', response.data)
		},
		loadInstitutionInfoAtForm: async ({ commit }, instId) => {
			const response = await institutionAPI.lookupInstInfo(instId)
			commit('setInstInfoAtForm', response.data)
		},
		setInstituteLicense: async ({ commit }, instId) => {
			const response = await institutionAPI.lookupLicense(instId)
			commit('setLicense', response.data)
		},
	},
}
export default institutionInformation
